import React, { useEffect, useState } from 'react';
import { useListVals } from 'react-firebase-hooks/database';
import { RouteComponentProps } from 'react-router-dom';
import { editGoalPageRoute, goalsPageRoute } from '../../common/linkRoutes';
import { ASSIGNED, BEHIND, COMPLETED, ON_PROGRESS } from '../../common/Types';
import Layout from '../../components/layout/Layout';
import { GoalI } from '../../interfaces/GoalInterface';
import { useStore } from '../../store/store';
import { DailyTaskI } from '../../interfaces/DailyTaskInterface';
import Task from '../../components/task/Task';
import Goal from '../../components/goal/Goal';
import { goalRef, taskRef } from '../../firebase/refs';
import { getByKey } from '../../firebase/refActions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faChevronDown,
  faChevronRight,
  faStar,
  faTimesCircle,
} from '@fortawesome/free-solid-svg-icons';
import './goalPage.css';
export type BasicProps = {
  children: React.ReactNode;
  location: Location;
  history: RouteComponentProps['history'];
};

const GoalPage = (props: BasicProps) => {
  const {
    goal,
    setRedirect,
    removeGoal,
    setGoal,
    completedGoal,
    updateGoal,
    user,
  } = useStore();

  const [taskList] = useListVals<any>(taskRef);

  const [goalObj, setGoalObj] = useState<GoalI | null>(null);
  const [goalTasks, setGoalTasks] = useState<DailyTaskI[]>([]);

  const [viewAllObj, setViewAllObj] = useState<any>({
    ON_PROGRESS: false,
    ASSIGNED: false,
    COMPLETED: false,
    BEHIND: false,
  });

  useEffect(() => {
    if (goal) {
      getByKey(goalRef, goal.key, (goalData: any) => {
        setGoalObj(goalData.data);
      });
    } else {
      setRedirect(goalsPageRoute);
    }

    return () => {
      taskRef.off();
      goalRef.off();
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (taskList && goalObj) {
      const list = taskList
        .filter((_t) => _t.user_uid === user?.uid)
        .filter((t) => t.goal_key === goalObj.key);
      setGoalTasks(list);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [taskList, goalObj]);

  return (
    <Layout pageName="Goal" backRoute={goalsPageRoute} {...props}>
      {goalObj ? (
        <>
          <Goal
            data={goalObj}
            redirectOnClick={editGoalPageRoute}
            task={
              <div style={{ display: 'flex' }}>
                <button
                  className="goal-card__action--button "
                  style={{
                    borderRadius: '70px',
                    margin: '0.4rem',
                    padding: '0.5rem',
                    backgroundColor: '#ff9b9b',
                  }}
                  onClick={() => {
                    if (
                      window.confirm(
                        `Delete this Goal & Tasks? Remember it'll be gone for good.`
                      )
                    ) {
                      setRedirect(goalsPageRoute);
                      setGoal(null);
                      removeGoal(goalObj);
                    }
                  }}
                >
                  <span>
                    Cancel Goal
                    <FontAwesomeIcon
                      icon={faTimesCircle}
                      style={{ marginLeft: '0.3rem' }}
                    />
                  </span>
                </button>
                {goalObj.goalStatus === COMPLETED ? (
                  <button
                    className="goal-card__action--button "
                    style={{
                      backgroundColor: '#d5ffdb',
                    }}
                    onClick={() => {
                      updateGoal({ ...goalObj, goalStatus: ON_PROGRESS });
                    }}
                  >
                    Not Completed
                  </button>
                ) : (
                  <button
                    className="goal-card__action--button "
                    style={{
                      backgroundColor: '#70ff83',
                    }}
                    onClick={() => {
                      completedGoal({ ...goalObj });
                    }}
                  >
                    <span>
                      Accomplished
                      <FontAwesomeIcon
                        icon={faStar}
                        style={{ marginLeft: '0.3rem' }}
                      />
                    </span>
                  </button>
                )}
              </div>
            }
          />
        </>
      ) : null}

      {renderTaskListByStatus(ON_PROGRESS)}
      {renderTaskListByStatus(ASSIGNED)}
      {renderTaskListByStatus(COMPLETED)}
      {renderTaskListByStatus(BEHIND)}
    </Layout>
  );

  function renderTaskListByStatus(status: string) {
    let _taskList = goalTasks.filter((_t) => _t.taskStatus === status);
    if (!_taskList.length) {
      return <></>;
    }

    if (!viewAllObj[status]) {
      _taskList = _taskList.slice(0, 2);
    }

    return (
      <div style={{ marginTop: '0.5rem', width: '100%' }}>
        <h2 style={{ textAlign: 'left' }}>
          {status}

          {viewAllObj[status] ? (
            <FontAwesomeIcon
              className="clickable"
              style={{ marginLeft: '0.5rem' }}
              icon={faChevronRight}
              onClick={() =>
                setViewAllObj({
                  ...viewAllObj,
                  [status]: !viewAllObj[status],
                })
              }
            />
          ) : (
            <FontAwesomeIcon
              className="clickable"
              style={{ marginLeft: '0.5rem' }}
              icon={faChevronDown}
              onClick={() =>
                setViewAllObj({
                  ...viewAllObj,
                  [status]: !viewAllObj[status],
                })
              }
            />
          )}
        </h2>
        {React.Children.toArray(_taskList.map((_t) => <Task data={_t} />))}
      </div>
    );
  }
};

export default GoalPage;
